/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Wry_Whale_NodInputs */

const en_crisp_wry_whale_nod = /** @type {(inputs: Crisp_Wry_Whale_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affected attributes:`)
};

const de_crisp_wry_whale_nod = /** @type {(inputs: Crisp_Wry_Whale_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betroffene Merkmale:`)
};

/**
* | output |
* | --- |
* | "Affected attributes:" |
*
* @param {Crisp_Wry_Whale_NodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_wry_whale_nod = /** @type {((inputs?: Crisp_Wry_Whale_NodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Wry_Whale_NodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_wry_whale_nod(inputs)
	return de_crisp_wry_whale_nod(inputs)
});